import React from "react";
import CmsLegalPage from "./CmsLegalPage";

export default function Privacy() {
    return <CmsLegalPage page="legal_privacy" fallbackTitle="Privacy Policy" fallbackUpdated="23 February 2026" />;
}
